import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faMobileScreenButton
} from "@fortawesome/pro-regular-svg-icons";

/**
 * NEW BOOKING SYSTEM - BOOKING SLOT ITEM COMPONENT
 * 
 * This component displays individual booking slots in the dashboard.
 * It shows slots created by business owners that are available for booking.
 */

const BookingSlotItem = ({
  bookingSlot: { 
    _id, 
    companyId, 
    serviceId, 
    start_time, 
    end_time, 
    duration, 
    status, 
    serviceInfo,
    companyInfo 
  }
}) => {
  const [phoneNumber, setPhoneNumber] = useState();
  
  let appt_date = moment(start_time);
  let date =
    moment(appt_date).format("MMM Do") +
    " @ " +
    moment(appt_date).format("h:mm a");

  let formatPhoneNumber = str => {
    //Filter only numbers from the input
    let cleaned = ("" + str)?.replace(/\D/g, "");

    //Check if the input is of correct length
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match == null || undefined) {
      setPhoneNumber(companyInfo?.phone);
    } else {
      let FormatedNumber = +match[1] + "-" + match[2] + "-" + match[3];
      setPhoneNumber(FormatedNumber);
      if (match) {
        return FormatedNumber;
      }
      return null;
    }
  };

  useEffect(() => {
    if (companyInfo?.phone) {
      formatPhoneNumber(companyInfo.phone);
    }
  }, [companyInfo]);

  return (
    <>
      <tr className="booking-item-row appo_table flex_column" id={_id}>
        <td className="booking-date">
          <Link to={`/bookings/${_id}`} className="small">
            <div className="upcom_date">{date}</div>
          </Link>
        </td>
        <td className="service_info">
          <i>
            <Link to={`/bookings/${_id}`} className="small">
              <p>{companyInfo?.name || 'Loading...'}&nbsp;-&nbsp;</p>
            </Link>
            <Link to={`/bookings/${_id}`} className="small">
              <p>{' '} {serviceInfo?.name || 'Loading...'}</p>
            </Link>
          </i>
          <p>
            <FontAwesomeIcon icon={faLocationDot} />
            {companyInfo?.location?.street_address || 'Address not available'}
          </p>
          {phoneNumber && (
            <p>
              <FontAwesomeIcon icon={faMobileScreenButton} />
              <a href={`tel:${phoneNumber}`} className="text-decoration-none">
                {phoneNumber}
              </a>
            </p>
          )}
        </td>
        <td className="booking-status">
          <span className={`badge ${
            status === 'available' ? 'badge-success' : 
            status === 'booked' ? 'badge-primary' : 
            status === 'cancelled' ? 'badge-danger' : 
            'badge-secondary'
          }`}>
            {status}
          </span>
        </td>
      </tr>
    </>
  );
};

BookingSlotItem.propTypes = {
  bookingSlot: PropTypes.object.isRequired,
};

export default BookingSlotItem;
